import { Component, OnInit } from '@angular/core';
import { CampaignStatus } from '../../core/enum/campaign-status.enum';
import { ActivatedRoute } from '@angular/router';
import { InvestmentService } from '../../core/services/api/investment.service';

@Component({
    selector: 'app-thank-you',
    templateUrl: './thank-you.component.html',
    standalone: false
})
export class ThankYouComponent implements OnInit {
  campaignSlug: string;
  investmentId: string;
  campaignStatus: string;
  paymentReferenceNo: string;

  constructor(
    private route: ActivatedRoute,
    private investmentService: InvestmentService,
  ) {}

  ngOnInit() {
    // Read slug from route params for campaign-specific path
    this.route.params.subscribe((routeParams) => {
      if (routeParams && routeParams['slug']) {
        this.campaignSlug = routeParams['slug'];
      }
    });

    // Read query params for payment reference or pledge details
    this.route.queryParams.subscribe((params) => {
      // Accept both `ref` and `paymentReferenceNo` for compatibility
      this.paymentReferenceNo = params['ref'] || params['paymentReferenceNo'];
      if (this.paymentReferenceNo) {
        this.investmentService.getInvestmentDetail(this.paymentReferenceNo).subscribe({
          next: (data) => {
            const { campaign } = data;
            this.campaignStatus = campaign.campaignStatus;
            // Use slug from API if not present in route
            if (!this.campaignSlug && campaign?.slug) {
              this.campaignSlug = campaign.slug;
            }
          },
        });
        return;
      }
      // Fallback for pay-later flow
      this.investmentId = params['investmentId'];
      this.campaignStatus = params['campaignStatus'];
      // If campaignSlug provided via query param, keep compatibility
      if (params['campaignSlug'] && !this.campaignSlug) {
        this.campaignSlug = params['campaignSlug'];
      }
    });
  }

  getImgSrc() {
    if (this.investmentId) {
      return '/assets/img/icons/svgs/thank-you-unpaid.svg';
    }
    return '/assets/img/icons/svgs/thank-you-paid.svg';
  }

  getTitle() {
    if (this.investmentId) {
      return 'investment.thankYouAlmostThere';
    }
    if (Number(this.campaignStatus) === CampaignStatus.PreLive) {
      return 'investment.thankYouEarlyBird';
    }
    return 'investment.thankYouConfirmed';
  }

  getSubtitle() {
    if (Number(this.campaignStatus) === CampaignStatus.PreLive) {
      return 'investment.thankYouEarlyBirdSubtitle';
    }
    return 'investment.thankYouSubtitle';
  }

  getParagraph() {
    if (this.investmentId) {
      return 'investment.thankYouParaUnpaid';
    }
    if (this.paymentReferenceNo) {
      return 'investment.thankYouParaConfirmed';
    }
    return 'investment.thankYouParaPending';
  }
}
